(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abrazofit-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'abrazofit-cd-end';
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function init(root) {
      if (root.getAttribute('data-af-ready')) return;
      root.setAttribute('data-af-ready', '1');
      var out = root.querySelector('[data-af-cd-time]');
      var span = (Number(root.getAttribute('data-hours')) || 3) * 3600 * 1000;
      var keep = root.getAttribute('data-keep') === 'true';
      var end = Date.now() + span;

      /* Por defecto la promoción se reinicia en cada ingreso (no se guarda nada en el navegador). */
      if (keep) {
        try {
          var saved = Number(window.localStorage.getItem(KEY));
          if (saved > 0) end = saved;
          else window.localStorage.setItem(KEY, String(end));
        } catch (e) {}
      }

      var timer = null;
      function tick() {
        if (!document.body.contains(root)) { clearInterval(timer); return; }
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) {
          if (keep) { s = 0; clearInterval(timer); }
          else { end = Date.now() + span; s = Math.floor(span / 1000); }
        }
        out.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-af-cd]')).forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abrazofit-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

    function initGallery(root) {
      if (root.getAttribute('data-af-ready')) return;
      root.setAttribute('data-af-ready', '1');
      var slides = $$('[data-af-slide]', root);
      var thumbs = $$('[data-af-thumb]', root);
      var seconds = Number(root.getAttribute('data-autoplay')) || 0;
      var col = root.querySelector('[data-af-gal]');
      var cur = 0, timer = null, hold = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle('is-on', k === cur); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      }
      function start() {
        clearInterval(timer);
        if (reduce || !seconds || slides.length < 2) return;
        timer = setInterval(function () {
          if (!document.body.contains(root)) { clearInterval(timer); return; }
          if (!hold && !document.hidden) show(cur + 1);
        }, seconds * 1000);
      }

      /* Cualquier clic manual reinicia el conteo */
      var prev = root.querySelector('[data-af-prev]');
      var next = root.querySelector('[data-af-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); start(); });
      if (next) next.addEventListener('click', function () { show(cur + 1); start(); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); start(); }); });

      if (col) {
        col.addEventListener('mouseenter', function () { hold = true; });
        col.addEventListener('mouseleave', function () { hold = false; });
        col.addEventListener('focusin', function () { hold = true; });
        col.addEventListener('focusout', function () { hold = false; });
      }
      show(0);
      start();
    }

    function initAll() { $$('[data-af-hero]').forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abrazofit-toast"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.getAttribute('data-af-ready')) return;
      root.setAttribute('data-af-ready', '1');
      var data;
      try { data = JSON.parse(root.querySelector('[data-af-toast-data]').textContent); } catch (e) { return; }
      if (!data.entries || !data.entries.length) return;
      var title = root.querySelector('[data-af-toast-title]');
      var text = root.querySelector('[data-af-toast-text]');
      var first = (Number(root.getAttribute('data-first')) || 6) * 1000;
      var every = (Number(root.getAttribute('data-interval')) || 35) * 1000;
      var visible = (Number(root.getAttribute('data-visible')) || 5) * 1000;
      var i = 0, hideT = null, loopT = null;

      function say() {
        if (!document.body.contains(root)) { clearInterval(loopT); return; }
        var p = data.entries[i++ % data.entries.length];
        title.textContent = String(data.format || '').replace('{name}', p.name).replace('{city}', p.city);
        text.textContent = data.text + (data.example ? ' ' + data.example : '');
        root.hidden = false;
        clearTimeout(hideT);
        hideT = setTimeout(function () { root.hidden = true; }, visible);
      }
      setTimeout(function () { say(); loopT = setInterval(say, every); }, first);
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-af-toast]')).forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (root.getAttribute('data-ma-ready')) return;
      root.setAttribute('data-ma-ready', '1');
      var track = root.querySelector('[data-ma-track]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ma-thumb]'));
      thumbs.forEach(function (b, i) {
        b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }, { passive: true });
    }
    function initAll() { Array.prototype.slice.call(document.querySelectorAll('[data-ma-hero]')).forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
